import React from 'react';
import { Button } from './ui/button';
import { ArrowDown, MessageCircle } from 'lucide-react';

const HeroSection = () => {
  const scrollToPortfolio = () => {
    const element = document.getElementById('portofolio');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/6285174247784', '_blank');
  };

  return (
    <section
      id="beranda"
      className="relative min-h-screen flex items-center justify-center pt-20"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('photo/0cover/cover4.jpg')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-fraunces font-bold text-white mb-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
          Abadikan Momen Bahagiamu
          <br />
          <span className="text-[#658C8D]">Bersama Kami</span>
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto font-lato animate-in fade-in slide-in-from-bottom-4 duration-700 delay-150">
          Kami menghadirkan dokumentasi foto dan video pernikahan yang elegan,
          romantis, dan penuh kenangan indah
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-in fade-in slide-in-from-bottom-4 duration-700 delay-300">
          <Button
            onClick={scrollToPortfolio}
            className="bg-white text-[#00382F] hover:bg-[#C1CCBC] transition-all duration-300 px-8 py-6 text-lg font-lato font-semibold flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            Lihat Portofolio
            <ArrowDown size={20} />
          </Button>
          <Button
            onClick={handleWhatsApp}
            className="bg-[#00382F] text-white hover:bg-[#00382F] transition-all duration-300 px-8 py-6 text-lg font-lato font-semibold flex items-center gap-2 shadow-lg hover:shadow-xl transform hover:scale-105"
          >
            <MessageCircle size={20} />
            Hubungi Kami
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;